module.exports = __webpack_public_path__ + "img/base2.71687a50.png";